import { FC } from 'react'

import { MasterCampaignPlanCustomSection } from 'api/interfaces/MasterCampaignPlan'
import { MasterCampaignPlanCampaignBuilder } from 'api/interfaces/MasterCampaignStub'

import { getBudgetContent } from '../utils/planContentUtils'
import CustomizableSection from './ExecutiveSummary/CustomizableSection'

export interface BudgetProps {
  campaigns: MasterCampaignPlanCampaignBuilder[]
  useMediaPlanWording?: boolean
  section?: MasterCampaignPlanCustomSection | null
  onEdit: () => void
  onDelete: () => void
  showActions?: boolean
}

const Budget: FC<BudgetProps> = ({ campaigns, useMediaPlanWording = false, section, onEdit, onDelete, showActions = true }) => {
  const budgetText = getBudgetContent(campaigns, useMediaPlanWording)

  return <CustomizableSection section={section} defaultTitle='Budget' defaultContent={budgetText} defaultShowTitle={true} separator='spacer' onEdit={onEdit} onDelete={onDelete} showActions={showActions} />
}

export default Budget
